import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';

import type { IStateUserScore, IUserScoreResponseDto, TScoringRequest } from 'entities/scoring';

export const scoresQueries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getScores: build.query<IStateUserScore, TScoringRequest>({
      query: (body) => ({
        url: BFF_API_ROUTES.getScores,
        body,
        method: 'POST',
      }),
      transformResponse: (value: IUserScoreResponseDto, _, arg) => {
        return {
          score: value.score,
          source: value.source,
          scoredUserData: JSON.stringify(arg),
          isLoading: false,
        };
      },
    }),
  }),
});

export const useGetScores = scoresQueries.useGetScoresQuery;
